module.exports = __webpack_public_path__ + "static/media/pre1.fccdc55d.jpg";